import React, { useEffect, useState } from "react";

import { Col, Container, Form, InputGroup, Row } from "react-bootstrap";

import { debounce } from "lodash";
import { ReactSVG } from "react-svg";

import { SearchIcon } from "@assets/icons";
import CrossIcon from "@assets/icons/streamline/cross-small.svg";

import styles from "./SearchInput.module.scss";

interface SearchInputProps {
  searchText: string;
  setSearchText: (value: string) => void;
  enterPressed: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({ searchText, setSearchText, enterPressed }) => {
  const [inputValue, setInputValue] = useState(searchText);

  const debouncedSetSearchText = debounce((value: string) => {
    setSearchText(value);
  }, 300);

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
  };

  useEffect(() => {
    debouncedSetSearchText(inputValue);
  }, [inputValue, debouncedSetSearchText]);

  const handleClearSearch = () => {
    setInputValue("");
    setSearchText("");
    debouncedSetSearchText.cancel();
  };

  useEffect(() => {
    // Cleanup debounce when component unmounts
    return () => {
      debouncedSetSearchText.cancel();
    };
  }, [debouncedSetSearchText]);

  return (
    <Container fluid className="d-inline">
      <Row>
        <Col>
          <Form.Group className={styles["resale-search"]}>
            <InputGroup>
              <InputGroup.Text>
                <ReactSVG src={SearchIcon} />
              </InputGroup.Text>
              <Form.Control
                name="resaleSearch"
                type="text"
                placeholder="Search by artist, artwork..."
                onChange={handleInput}
                onKeyDown={enterPressed}
                value={inputValue}
              />
              {inputValue && (
                <InputGroup.Text className={styles["cross-icon"]}>
                  <ReactSVG src={CrossIcon} onClick={handleClearSearch} />
                </InputGroup.Text>
              )}
            </InputGroup>
          </Form.Group>
        </Col>
      </Row>
    </Container>
  );
};

export default SearchInput;
